// extracted by mini-css-extract-plugin
export default {"mobile":"mobile_mobile__6jW+F","logo":"mobile_logo__YLvSN"};